import type { PushNotificationContent } from '../entities/push_notification.entity'
import type { PushNotificationRepository } from '../repositories/push_notification_repository'

export class SendPushToUserUseCase {
  constructor(private readonly repository: PushNotificationRepository) {}

  execute(userId: string, content: PushNotificationContent): Promise<void> {
    return this.repository.sendToUser(userId, content)
  }
}
